<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Configuração de valores por escola (R$)</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="escolaId">Escola</label>
                                    <select v-select="{ dataitem: 'Escola', default: 'Selecione', filters:{AttributeBehavior:'EscolaMaisSituacao'}}" v-model="filter.escolaId" class="form-control" name="escolaId"></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label>Venda Liberada</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="vendaLiberada" v-model="filter.vendaLiberada" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="vendaLiberada" v-model="filter.vendaLiberada" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="vendaLiberada" v-model="filter.vendaLiberada" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <section class="col-sm-12">
                                <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                            </section>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <label class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" v-model="selecionarTodos" @click="selecionaTodos()">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description"></span>
                                        </label>
                                    </th>
                                    <th>Escola<i @click="executeOrderBy('escola.nomeEscola')" class="fa fa-sort"></i></th>
                                    <th>Estágio Utilizado<i @click="executeOrderBy('ValorEstagio')" class="fa fa-sort"></i></th>
                                    <th>Estágio Sugerido<i @click="executeOrderBy('ValorEstagioSugerido')" class="fa fa-sort"></i></th>
                                    <th>M.D Utilizado<i @click="executeOrderBy('ValorMaterialDidatico')" class="fa fa-sort"></i></th>
                                    <th>M.D Sugerido<i @click="executeOrderBy('ValorMaterialDidaticoSugerido')" class="fa fa-sort"></i></th>
                                    <th>VendaLiberada<i @click="executeOrderBy('VendaLiberada')" class="fa fa-sort"></i></th>

                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>
                                        <label class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" v-model="selecionados" :value="item.escolaEstagioId">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description"></span>
                                        </label>
                                    </td>
                                    <td>{{ item.escola.nomeEscola }}</td>
                                    <td>{{ item.valorEstagio }}</td>
                                    <td>{{ item.valorEstagioSugerido }}</td>
                                    <td>{{ item.valorMaterialDidatico }}</td>
                                    <td>{{ item.valorMaterialDidaticoSugerido }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.vendaLiberada, 'badge-danger': !item.vendaLiberada }">{{item.vendaLiberada ? 'Sim' : 'Não'}}</span></td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ escolaEstagioId: item.escolaEstagioId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" @click="openRemove({ escolaEstagioId: item.escolaEstagioId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>
                    <div>
                        <b-dropdown id="dropdown" text="Alterar liberação de venda" variant="primary" class="m-2">
                            <b-dropdown-item @click="AlteraLiberacaoVenda(true)" class="btn-outline-success" >Ativar todos selecionados</b-dropdown-item>
                            <b-dropdown-item @click="AlteraLiberacaoVenda(false)" class="btn-outline-danger" >Inativar todos selecionados</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="escolaEstagioId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'escolaestagio',
        mixins: [base],
        props: { estagioId: Number },
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'escolaestagio',
                    remove: 'escolaestagio',
                    alteraLiberacaoVenda: 'escolaestagio/alteraLiberacaoVenda'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                selecionarTodos: false,
                selecionados: [],

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.escolaEstagioId = model.escolaEstagioId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },
            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.estagioId = this.estagioId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
            selecionaTodos: function() {
                this.selecionados = [];

                if (!this.selecionarTodos) {
                    for (var item in this.result.items)
                        this.selecionados.push(this.result.items[item].escolaEstagioId);
                }
            },
            AlteraLiberacaoVenda: function(value) {
                if (this.selecionados.length < 1) {
                    this.defaultErrorResult('Nenhum registro selecionado');
                    return;
                }
                this.showLoading();
                new Api(this.resources.alteraLiberacaoVenda).post({ ids: this.selecionados, liberaVenda: value }).then(data => {
                    this.defaultSuccessResult("Itens atualizados com sucesso");
                    this.selecionados = [];
                    this.selecionarTodos = false;
                    this.executeLoad();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>